const jumpLinks = document.querySelectorAll('.block-jump-navigation') as NodeListOf<HTMLElement>;

jumpLinks.forEach((block: HTMLElement) => {
	const button = block.querySelector('.block-jump-navigation__button');
	const nav = block.querySelector('.block-jump-navigation__container');
	const links = block.querySelectorAll(
		'.block-jump-navigation__container nav ul li a'
	) as NodeListOf<HTMLElement>;
	links.forEach((jumpLink: HTMLElement) => {
		jumpLink.addEventListener('click', () => {
			if (window.innerWidth <= 991) {
				button?.setAttribute('aria-expanded', 'false');
				nav?.setAttribute('aria-expanded', 'false');
				links.forEach((link: HTMLElement) => {
					link.setAttribute('aria-expanded', 'false');
				});
			}
		});
	});
});
